import CookieAction from "./CookieAction";
import vi18n from "../vi18n.js";
import VueCookie from "vue-cookies";

// let vm;
// let xpath = location.pathname.split("/");
//
// if (xpath[1] === "user") {
//   switch (xpath[2]) {
//     case "login":
//       vm = import("../pages/login/main.js");
//       break;
//     case "join":
//       vm = import("../pages/join/main.js");
//       break;
//     case "reset_password":
//       vm = import("../pages/reset_password/main.js");
//       break;
//     case "password":
//       vm = import("../pages/change_password/main.js");
//       break;
//     case "auth_email_send": // 인증메일 발송
//       vm = import("../pages/auth_email_send/main.js");
//       break;
//     case "approve":
//       vm = import("../pages/auth_email_approve/main.js");
//       break;
//     case "auth_email_before_confirm": // 로그인 실패(401)
//       vm = import("../pages/auth_email_before_confirm/main.js");
//       break;
//     default:
//       vm = import(`../pages/${xpath[2]}/main.js`);
//       break;
//   }
// } else if (xpath[1] === "dev") {
//   vm = import(`../pages/dev/${xpath[2]}/main.js`);
// } else {
//   vm = import(`../pages/${xpath[1]}/main.js`);
// }

// let domain = ".imqa.io";
let cookie = {};
// let regex = /\_([^\]]+)\_/;

class Cookie {
  list = {
    lang: new CookieAction(function () {
      vi18n.global.locale = VueCookie.get("lang");
    }),
    timezone: new CookieAction(function () {}),
    screen_detail: new CookieAction(function () {
      // vm.$i18n.locale = vm.$cookie.get('screen_detail');
    }),
    theme: new CookieAction(function () {}),
    view_mode: new CookieAction(function () {}),
  };

  constructor() {
    /*pass */
    // setTimeout(() => {
    //   vm = vm.default;
    // }, 0);
  }

  set(key, value) {
    setTimeout(() => {
      if (this.validKey(key)) {
        if (key == "timezone") {
          let session = cookie.session.replace(/SESSION/g, "");
          key = `${session}TIMEZONE`;
        }
        VueCookie.set(key, value, "", "", cookie.domain);
      }
      for (let atom in this.list) {
        this.list[atom].action();
      }
    }, 0);
  }

  get(key) {
    if (key == "timezone") {
      let session = cookie.session.replace(/SESSION/g, "");
      key = `${session}TIMEZONE`;
    }
    return VueCookie.get(key);
  }

  setInit(value) {
    cookie = value;
  }

  clearKey() {
    let session = cookie.session.replace(/SESSION/g, "");
    let domainTimezone = `${session}TIMEZONE`;
    let domainSession = `${session}SESSION`;
    let localTimezone = "local_timezone";
    let loginSave = "IMQA_LOGIN_SAVE";
    let loginCookie = "IMQA_LOGIN_COOKIE";
    let cookies = document.cookie.split("; ");
    let result, key;
    for (let c of cookies) {
      key = c.split("=")[0];
      result = false;
      if (
        key === domainTimezone ||
        key === domainSession ||
        key === localTimezone ||
        key === loginSave ||
        key === loginCookie
      ) {
        continue;
      }
      for (let atom in this.list) {
        if (atom == key) {
          result = true;
          break;
        }
      }
      if (!result) {
        VueCookie.remove(key, {
          domain: cookie.domain,
        });
      }
    }
  }

  validKey(data) {
    let result = false;
    for (let atom in this.list) {
      if (atom == data) {
        return true;
      }
    }
    return result;
  }
}

export default new Cookie();
